import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getPageHeadersConfigs() {
    return {
        custom: {
            [PALETTE_IDS.INTERFACE]: {
                ApplicationMenu: {
                    logo: {
                        style: {
                            height: 32,
                            _mobile_height: 24,
                            width: 155,
                            _mobile_width: 117,
                        },
                    },
                    logoButton: {
                        style: {
                            base: {
                                flexBasis: 155,
                                _mobile_flexBasis: 117,
                            },
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.APPLICATION_HEADER]: {
                APPLICATION_HEADER_USER_INFO_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_XSMALL,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                APPLICATION_HEADER_USER_INFO_BALANCE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_XSMALL,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                APPLICATION_HEADER_USER_INFO_ICON_COLOR: COLOR.BRAND.ACCENT1,

                APPLICATION_HEADER_NAV_BAR_BG: COLOR.BRAND.BACKGROUND4,
                APPLICATION_HEADER_NAV_BAR_PAGE_SELECTOR: {
                    PIVOT_TEXT: {
                        fontFamily: FONT.FAMILY,
                        color: COLOR.BRAND.FOREGROUND1,
                        textTransform: 'uppercase',
                        fontStyle: 'initial',
                    },
                    PIVOT_SELECTED_TEXT: {
                        fontFamily: FONT.FAMILY,
                        color: COLOR.BRAND.FOREGROUND1,
                        textTransform: 'uppercase',
                        fontStyle: 'initial',
                    },
                    PIVOT_INDICATOR_HEIGHT: 0,
                },
                APPLICATION_HEADER_NAV_BAR_SEARCH_INPUT: {
                    INPUT_BG: COLOR.BRAND.BACKGROUND5,
                    INPUT_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                    INPUT_BORDER_COLOR: COLOR.RESERVED.TRANSPARENT,
                    INPUT_FOCUSED_BORDER_COLOR: COLOR.RESERVED.TRANSPARENT,
                    INPUT_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                    INPUT_FOCUSED_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                    INPUT_PLACEHOLDER_TEXT: COLOR.BRAND.FOREGROUND3,
                },
                SEARCH_POPOVER: {
                    POPOVER_BG: COLOR.BRAND.BACKGROUND4,
                    POPOVER_TEXT: COLOR.BRAND.FOREGROUND1,
                },
            },
            [PALETTE_IDS.INTERFACE]: {
                APP_BANNER_CLOSE_ICON: COLOR.BRAND.FOREGROUND2,
                COOKIE_CONSENT_POLICY_BUTTON: {
                    SECONDARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        borderColor: COLOR.BRAND.FOREGROUND2,
                    },
                },
                APP_BANNER_BUTTON: {
                    SECONDARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        borderColor: COLOR.BRAND.FOREGROUND2,
                    },
                },
                SYSTEM_INITIALIZATION_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    fontSize: FONT.SIZE_SMALL,
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                },
            },
            [PALETTE_IDS.BREADCRUMBS]: {
                BREADCRUMBS_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    textTransform: 'uppercase',
                    color: COLOR.BRAND.FOREGROUND1,
                    fontStyle: 'italic',
                },
                BREADCRUMBS_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                BREADCRUMBS_BACK_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                BREADCRUMBS_QUICK_NAVIGATION_CATEGORY_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                    fontSize: 10, // according to Zeplin
                },
                BREADCRUMBS_QUICK_NAVIGATION_TOURNAMENT_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                    fontSize: FONT.SIZE_SMALL,
                },

                MOBILE_BREADCRUMBS_BG: COLOR.BRAND.BACKGROUND1,
                MOBILE_BREADCRUMBS_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                MOBILE_BREADCRUMBS_BACK_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND2,

                EVENT_NOTIFICATION_SUBSCRIBER_SWITCH: {
                    SWITCH_LABEL_TEXT: {
                        color: COLOR.BRAND.FOREGROUND4,
                        fontFamily: FONT.FAMILY_FUTURA,
                        fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                        fontSize: FONT.SIZE_XSMALL,
                        textTransform: 'uppercase',
                        fontStyle: 'italic',
                    },
                },
            },
            [PALETTE_IDS.SETTINGS]: {
                SETTINGS_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    fontStyle: 'italic',
                    fontSize: 18,
                    textTransform: 'uppercase',
                },
            },
        },
    };
}
